import { countries } from 'countries-list';

import { CountryProps } from 'app/components/UI/Inputs/PhoneNumberInput/CountrySearchList/types';

const getCountries = (): CountryProps[] => {
  return Object.entries(countries)
    .map((country) => {
      return { code: country[0], details: country[1] };
    })
    .sort((a, b) => {
      return a.details.name >= b.details.name ? 1 : -1;
    });
};

export default getCountries;
